/**
 * @class Header
 * @param element HTMLElement
 * @constructor
 */
function Header(element){
	if(element === null){
		throw new TypeError("Invalid element.");
	}

	this._element = element;
	this._document = element.ownerDocument;
	this._window = this._document.defaultView;

	this._document.addEventListener("scroll", this._scrollHandler.bind(this), false);
	this._scrollHandler();

	this._links = this._element.getElementsByClassName("header_nav-link");
	var linkClickHandlerBound = this._linkClickHandler.bind(this);
	for(var linkIndex = 0, numLinks = this._links.length; linkIndex < numLinks; linkIndex++){
		this._links[linkIndex].addEventListener("click", linkClickHandlerBound, false);
	}
	this._element.getElementsByClassName("header_title-link")[0].addEventListener("click", linkClickHandlerBound, false);
	//TODO handle the case when the user abort changing page. It's possible?
	//window.addEventListener("beforeunload",
}
Header.HEIGHT = 78;
Header.STICKY_HEIGHT = 43;

/** @type DocumentView */
Header.prototype._window = null;
/** @type HTMLDocument */
Header.prototype._document = null;
/** @type HTMLElement */
Header.prototype._element = null;
/** @type NodeList */
Header.prototype._links = null;

/**
 *
 * @param event Event
 * @private
 */
Header.prototype._scrollHandler = function _scrollHandler(event){
	var diff = Header.HEIGHT - Header.STICKY_HEIGHT;
	// http://stackoverflow.com/questions/1338224/how-do-i-get-the-window-object-from-the-document-object
	// Should use scrollY instead
	if(this._window.scrollY > diff){
		this._element.classList.add("header--sticky");
	}else{
		this._element.classList.remove("header--sticky");
	}
};

/**
 *
 * @param {MouseEvent} event
 * @private
 */
Header.prototype._linkClickHandler = function _linkClickHandler(event){
	// Only Left button (or Right button for left-handed use mouses)
	if(event.button != 0 || event.altKey || event.ctrlKey || event.metaKey){
		return;
	}
	var element = event.currentTarget;
	for(var link, linkIndex = 0, numLinks = this._links.length; linkIndex < numLinks; linkIndex++){
		link = this._links[linkIndex];
		if(link === element){
			link.classList.add("header_nav-link--current");
		}else{
			link.classList.remove("header_nav-link--current");
		}
	}
};